/**
 * Browser-side parsers that read an importer's transactions out of the
 * vendor's invoice PDF.
 *
 * An importer names one of these in its `invoice_parser` config field; the
 * worker has no PDF reader, so the extraction and the parse both happen here
 * and the result is uploaded as a CSV in that importer's own column schema.
 * Adding a bank means adding a parser here and naming it in the config —
 * nothing in the backend changes.
 */
import { parseStatement, statementToCsv } from "./dnb-statement";

/** Turn extracted PDF text into a CSV the named importer can read. */
export type StatementParser = (text: string) => string;

const PARSERS: Record<string, StatementParser> = {
  "dnb-mastercard": (text) => statementToCsv(parseStatement(text).rows),
};

export const statementParser = (id: string): StatementParser | undefined =>
  PARSERS[id];
